import { Form } from 'antd';
import { ContentFilters } from 'components';
import dayjs from 'dayjs';
import { OfferFilterForm } from 'features/discount-code/components/filter-form/offer-filter-form/offer-filter-form';
import {
  OfferFilterFormPaginated,
  OfferFilterFormValues,
} from 'features/discount-code/components/filter-form/offer-filter-form/type';
import { OfferTable } from 'features/discount-code/components/offer-table/offer-table';
import { OfferTopBar } from 'features/discount-code/components/top-bar/offer-top';
import { useGetOfferList } from 'features/discount-code/use-cases/get-offer-list';
import { usePaginationParams } from 'hooks';
import { omit } from 'lodash';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { formatDate } from 'utils/date';

const initialFilterValues: OfferFilterFormValues = {
  Title: undefined,
  date: [undefined, undefined],
  IsActive: undefined,
};

export const OfferListView = () => {
  const { params, updateParams, resetPage } =
    usePaginationParams<OfferFilterFormPaginated>({
      page: 1,
      size: 10,
      ...initialFilterValues,
    });
  const preparePayload = (paramsw: OfferFilterFormPaginated) => {
    const createdAtFrom = paramsw.date?.[0];
    const createdAtTo = paramsw.date?.[1];

    return {
      ...omit(params, ['date']),
      fromDate: createdAtFrom
        ? formatDate({
            date: dayjs(createdAtFrom).startOf('day'),
            format: 'isoDate',
          })
        : undefined,
      toDate: createdAtTo
        ? formatDate({
            date: dayjs(createdAtTo).startOf('day'),
            format: 'isoDate',
          })
        : undefined,
    };
  };
  const { data, isFetching, refetch } = useGetOfferList(preparePayload(params));
  const handleFiltersChange = (values: OfferFilterFormValues) => {
    updateParams(values);
    resetPage();
  };
  const formId = 'users-with-wallet-filters-form';
  const [form] = Form.useForm<OfferFilterFormValues>();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/discount-code/offer-list') {
      document.body.style.overflow = 'visible';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [location]);

  return (
    <div>
      <OfferTopBar
        refetch={refetch}
        form={form}
        resetPage={resetPage}
        handleFilter={handleFiltersChange}
        initialValues={initialFilterValues}
      />
      <ContentFilters formId={formId}>
        <OfferFilterForm
          form={form}
          formId={formId}
          handleFilter={handleFiltersChange as any}
          initialValues={initialFilterValues as any}
        />
      </ContentFilters>
      <OfferTable
        isLoading={isFetching}
        data={data}
        tableParams={params}
        updateParams={updateParams}
        refetch={refetch}
      />

      <Outlet />
    </div>
  );
};
